export function d (...args) {
  return console.log('[yzh]', ...args)
}

export function t (debug, ...args) {
  if (debug) {
    return console.log('[yzh]', ...args)
  }
}

export function debug (...args) {
  return console.debug(...args)
}

export function i (...args) {
  return console.info(...args)
}

export function e (...args) {
  return console.error(...args)
}



// WEBPACK FOOTER //
// ./src/utils/logUtil.js